import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import Slider from "react-slick";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

import SpQuotes from "../../img/decor/sp-quotes.svg";

import Nataliia_Teriakhina from "../../img/speaker-quotes/Nataliia_Teriakhina.webp";
import Ihor_Liski from "../../img/speaker-quotes/Ihor_Liski.webp";
import Petro_Lukiyanchuk from "../../img/speaker-quotes/Petro_Lukiyanchuk.webp";
import Natalia_Korol from "../../img/speaker-quotes/Natalia_Korol.webp";
import Tetiana_Sherman from "../../img/speaker-quotes/Tetiana_Sherman.webp";
import Tetiana_Popova from "../../img/speaker-quotes/Tetiana_Popova.webp";
import Mariana_Kosharnovska from "../../img/speaker-quotes/Mariana_Kosharnovska.webp";
import Vyusal_Talibov from "../../img/speaker-quotes/Vyusal_Talibov.webp";
import Natalia_Yemchenko from "../../img/speaker-quotes/Natalia_Yemchenko.webp";


function Quotes() {
    const sliderRef = React.useRef(null);

    const quotesContent = [
        
        {
            name: "Наталія Теряхіна",
            position: "HRD Kernel",
            img: Nataliia_Teriakhina,
            text: "Важливо не конкурувати на ринку праці, а розширювати ринок праці. Тобто шукати інструменти, як зробити кандидатів на тому ринку праці, на якому ви працюєте, більше, а не менше."
        },
        {
            name: "Ігор Ліскі",
            position: "засновник EFI Group",
            img: Ihor_Liski,
            text: "Треба не боятися змін. Шукати людей з цікавістю до змін, до нового. Ці люди будуть драйверами інновацій та нових підходів."
        },
        {
            name: "Петро Лукіянчук",
            position: "лідер ветеранської спільноти Групи Нафтогаз, керівник пресцентру Львівської філії ТОВ «Газорозподільні мережі України»",
            img: Petro_Lukiyanchuk,
            text: "Найважливіше – це концепція «свій до свого». Тобто коли ветеран безпосередньо потрапляє в спільноту ветеранів, коли спілкується за форматом «рівне є рівному»."
        },
        {
            name: "Наталя Король",
            position: "директорка департаменту з управління персоналом та трансформації бізнесу ТАС Агро",
            img: Natalia_Korol,
            text: "Люди дуже хочуть працювати в компанії, де вибудовані процеси. Будуйте процеси, будьте системними, впроваджуйте найкращі практики – і через це ваш бренд буде зростати."
        },
        {
            name: "Тетяна Шерман",
            position: "керівниця з розвитку бізнесу та партнерств Academy DTEK",
            img: Tetiana_Sherman,
            text: "Вкрай важливо саме сьогодні, в наші непрості часи, збиратися в офлайн-форматі. Лише в момент, коли людина зустрічає іншу людину, ми відчуваємо той рівень енергії, емпатії, співчуття, той рівень залученості, який неможливо зробити на відстані."
        },
        {
            name: "Тетяна Попова",
            position: "Chief Human Resources Officer Uklon ",
            img: Tetiana_Popova,
            text: "Перш за все, людям потрібні люди. Цінність цього заходу – це, перш за все, отримати один від одного певні інсайти: що я можу взяти собі в компанію вже зараз, а що буде актуальне пізніше. "
        },
        {
            name: "Мар’яна Кошарновська",
            position: "старша менеджерка з персоналу AB InBev Efes Ukraine",
            img: Mariana_Kosharnovska,
            text: "HR-спільнота просто налаштовує тебе думати ширше, цікавіше, на якісь неймовірні ідеї. Обожнюю нетворкінг. Багато колег і знайомих побачила на івенті. Тому офлайн зустрічі – це must have."
        },
        {
            name: "Вюсал Талибов",
            position: "HRD Foundation Coffee Roasters",
            img: Vyusal_Talibov,
            text: "Нам дуже не вистачало цієї комунікації – можливості ділитися досвідом, говорити про те, хто в якому секторі як оптимізував або покращив свої процеси. Такі заходи точно впливають і змінюють культуру, ринок та середовище, у якому працюють HR-фахівці."
        },
        {
            name: "Наталія Ємченко",
            position: "директорка зі зв’язків з громадськістю та комунікацій SCM, голова наглядових рад ГО «Серце Азовсталі» та Фонду Ріната Ахметова ",
            img: Natalia_Yemchenko,
            text: "Не сприймати ветеранську політику як соціальну програму. Це частина бізнес-процесів, де ветеран – важлива інтегральна частина колективу. І з ним потрібно працювати як з невід'ємною частиною бізнес-організму."
        }
    ];

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
    };

    return (
        <section className="relative mb-[60px] lg:mb-[120px] ">
            <div className="container max-w-screen-xl mx-auto relative z-30 px-[15px] pb-20 lg:pb-0">

                <img src={SpQuotes} className="hidden md:block absolute z-10 -top-8 right-6 lg:right-36" alt="Quotes" />

                <div className="flex items-center justify-center gap-4 absolute bottom-0 left-1/2 -translate-x-1/2
                lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 lg:left-0 lg:translate-x-0 lg:justify-between w-full z-10">
                    <button className="p-3 opacity-40 hover:opacity-100 transition" onClick={() => sliderRef.current?.slickPrev()}>
                        <SlArrowLeft className="text-3xl" />
                    </button>

                    <button className="p-3 opacity-40 hover:opacity-100 transition" onClick={() => sliderRef.current?.slickNext()}>
                        <SlArrowRight className="text-3xl" />
                    </button>
                </div>


                <Slider
                    ref={sliderRef}
                    {...settings}
                    className="[&_.slick-track]:flex [&_.slick-track]:items-start [&_.slick-slide]:h-auto [&_.slick-slide>div]:h-full"
                >
                    {quotesContent.map((item, index) => (
                        <div className="lg:px-12" key={index}>
                            <div className="flex flex-col items-center md:flex-row md:gap-6 lg:gap-10 ">

                                {/* Фото */}
                                <div className="mb-3 md:m-0 lg:w-full lg:max-w-[430px] lg:flex-shrink-0"> 
                                   <img src={item.img} alt={item.name} />
                                </div>

                                {/* Текст */}
                                <div className="relative">
                                    <img src={SpQuotes} className="absolute md:!hidden z-10 -top-10 right-6" alt="Quotes" />

                                    <h3 className="text-xl font-semibold mb-3 lg:text-3xl">
                                        {item.name}
                                    </h3>

                                    <p className="font-semibold mb-5 lg:text-lg">
                                        {item.position}
                                    </p>

                                    <div className="text-justify lg:text-base">
                                        {item.text}
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
}


export default Quotes